import * as Yup from 'yup';

const specialChars = `-!"#$%&'()*+,./:;<=>?@[\\]^_\`{|}~§€`;

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('* Obligatoriskt fält')
    .min(8, 'Lösenordet måste vara minst 8 tecken långt.')
    .max(20, 'Lösenordet får vara högst 20 tecken långt.')
    .matches(/[A-Z]/, 'Lösenordet måste innehålla minst en versal (A–Z).')
    .matches(/[a-z]/, 'Lösenordet måste innehålla minst en gemen (a–z).')
    .matches(/[0-9]/, 'Lösenordet måste innehålla minst en siffra (0–9).')
    .matches(
      new RegExp(`[${specialChars}]`),
      `Lösenordet måste innehålla minst ett specialtecken. Tillåtna tecken: ${specialChars}`
    ),
  confirm_password: Yup.string()
    .required('* Obligatoriskt fält')
    .oneOf([Yup.ref('password')], 'Lösenorden matchar inte.'),
});
